/** True on the candidate apply subdomain (apply.hiromatch.com). */
export function isApplySite(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'apply.hiromatch.com' || host.startsWith('apply.');
}

const RESERVED_FIRST_SEGMENTS = new Set([
  'contact',
  'faq',
  'privacy',
  'terms',
  'cookies',
  'ai-transparency',
  'dpa',
  'subprocessors',
  'login',
  'signup',
  'onboarding',
  'dashboard',
  'job-positions',
  'applications',
  'postings',
  'settings',
  'profile',
  'support',
  'admin',
  'i',
]);

/** Public posting landing: /{companySlug}/{postingId} or /apply/{companySlug}/{postingId}. */
export function isPublicApplyPath(pathname: string): boolean {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 3 && parts[0] === 'apply') {
    return !RESERVED_FIRST_SEGMENTS.has(parts[1]!.toLowerCase());
  }
  if (parts.length === 2) {
    return !RESERVED_FIRST_SEGMENTS.has(parts[0]!.toLowerCase());
  }
  return false;
}

export function isPublicApplyContext(pathname?: string): boolean {
  if (isApplySite()) return true;
  const path = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  return isPublicApplyPath(path);
}
